export const FAILURE = 'failure';
export const INITIAL = 'initial';
export const LOADING = 'loading';
export const PARTIALLY_HYDRATED = 'partially_hydrated';
export const PROCESSING = 'processing';
export const SAVING = 'saving';
export const SUCCESS = 'success';
export const TESTING = 'testing';

export const NOT_FOUND = 404;
